module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"successTitle":"Email verified!","successContent":"Congrats! Your email has been verified.","continue":"Continue","errorContent":"Your email verification failed, please contact the admin"},"cn":{"successTitle":"邮件验证成功！","successContent":"您的邮箱已经成功验证。","continue":"继续","errorContent":"您的邮箱验证失败，请联系管理员"}}')
  delete Component.options._Ctor
}
